module.exports = __webpack_public_path__ + "img/ku1.82772f30.png";